import { BoloPanelFormType } from '@mark43/cad-api';
import { entityContainsValidKeys } from '../../../panels/entity-panels/forms/entity-filtering';

export function filterInvalidBoloFormEntities(boloPanelForm: BoloPanelFormType): BoloPanelFormType {
    return {
        ...boloPanelForm,
        involvedVehicles: boloPanelForm.involvedVehicles.filter((vehicle) =>
            entityContainsValidKeys(vehicle, ['vinNumber', 'plateNumber'])
        ),
        involvedPersons: boloPanelForm.involvedPersons.filter((person) =>
            entityContainsValidKeys(person, [
                'firstName',
                'lastName',
                'phoneNumber',
                'phoneExtension',
                'location',
                'locationSubPremise',
                'notes',
            ])
        ),
    };
}
